module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#proofread",
      toString: function () {
        return this.url;
      }
    }